import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = 'teamMeetingConfig';

export interface ITeamMeetingConfigQueryParams {
	id: string;
	enabled?: boolean;
}

export function useTeamMeetingConfigQuery({ id, enabled = true }: ITeamMeetingConfigQueryParams) {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.ITeamMeetingConfig>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `TeamMeetingConfig/${id}`,
				}),
				'GET'
			);
		},
		queryKey: [BASE_API_KEY, 'detail', id],
		enabled: enabled && !!id,
	});
}

export const invalidateTeamMeetingConfigQuery = (id: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY, 'detail', id] });
};
